import React from "react";

const ItemDetails = ({
  items,
  itemErrors,
  handleItemChange,
  handleItemBlur,
  handleAddItem,
  handleRemoveItem,
  canAddMoreItems,
  isLoading,
  error,
}) => {
  return (
    <>
      <div className="row mt-4">
        <div className="col-12">
          <div className="form-heading d-flex justify-content-between align-items-center mb-3">
            <div>
              <h4 className="mb-0">Items Details</h4>
            </div>
            <button
              type="button"
              className="btn add-pluss"
              style={{
                backgroundColor: "var(--primary-clr)",
                color: "white",
              }}
              onClick={handleAddItem}
              disabled={!canAddMoreItems || isLoading}
              title={
                !canAddMoreItems
                  ? "Complete current item details to add more"
                  : "Add new item"
              }
            >
              <i className="fa fa-plus me-1"></i> Add Item
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th
                    style={{ width: "5%", verticalAlign: "middle" }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th
                    style={{
                      width: "25%",
                      verticalAlign: "middle",
                    }}
                  >
                    Item Name <span className="text-danger">*</span>
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Unit
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    HSN No
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Quantity <span className="text-danger">*</span>
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Rate (₹) <span className="text-danger">*</span>
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Amount (₹)
                  </th>
                  <th
                    style={{
                      width: "10%",
                      verticalAlign: "middle",
                    }}
                    className="text-center"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr
                    key={index}
                    className={
                      itemErrors[index]?.item_name ||
                      itemErrors[index]?.quantity ||
                      itemErrors[index]?.rate
                        ? ""
                        : ""
                    }
                  >
                    <td className="text-center align-middle">
                      <strong>{index + 1}</strong>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${
                          itemErrors[index]?.item_name ? "is-invalid" : ""
                        }`}
                        value={item.item_name}
                        onChange={(e) =>
                          handleItemChange(index, "item_name", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "item_name")}
                        placeholder="Enter item name"
                      />
                      {itemErrors[index]?.item_name && (
                        <small className="text-danger">
                          {itemErrors[index].item_name}
                        </small>
                      )}
                    </td>
                    <td>
                      <select
                        className="form-control form-control-sm"
                        value={item?.unit_name || ""}
                        onChange={(e) =>
                          handleItemChange(index, "unit_name", e.target.value)
                        }
                      >
                        <option value="">Select Unit</option>
                        <option value="Pcs">Pcs</option>
                        <option value="Kg">Kg</option>
                        <option value="Gram">Gram</option>
                        <option value="Meter">Meter</option>
                        <option value="Liter">Liter</option>
                        <option value="Set">Set</option>
                        <option value="Box">Box</option>
                        <option value="Nos">Nos</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={item.hsn_no}
                        onChange={(e) =>
                          handleItemChange(index, "hsn_no", e.target.value)
                        }
                        placeholder="HSN"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className={`form-control form-control-sm ${
                          itemErrors[index]?.quantity ? "is-invalid" : ""
                        }`}
                        value={item.quantity}
                        onChange={(e) =>
                          handleItemChange(index, "quantity", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "quantity")}
                        placeholder="0"
                        min="0"
                        step="0.01"
                      />
                      {itemErrors[index]?.quantity && (
                        <small className="text-danger">
                          {itemErrors[index].quantity}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="number"
                        className={`form-control form-control-sm ${
                          itemErrors[index]?.rate ? "is-invalid" : ""
                        }`}
                        value={item.rate}
                        onChange={(e) =>
                          handleItemChange(index, "rate", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "rate")}
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                      />
                      {itemErrors[index]?.rate && (
                        <small className="text-danger">
                          {itemErrors[index].rate}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        value={`₹ ${item.amount}`}
                        readOnly
                        style={{ fontWeight: "600" }}
                      />
                    </td>
                    <td className="text-center align-middle">
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleRemoveItem(index)}
                        disabled={items.length === 1 || isLoading}
                        title="Delete Item"
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {error.items && (
              <div className="alert alert-danger mt-2 py-2">
                <i className="fa fa-exclamation-circle me-2"></i>
                {error.items}
              </div>
            )}
            {!canAddMoreItems && items.length > 0 && (
              <div
                className="alert mt-2 py-2"
                style={{
                  backgroundColor: "rgba(255, 105, 35, 0.1)",
                  border: "1px solid var(--primary-clr)",
                  color: "var(--primary-clr)",
                  fontSize: "12px",
                }}
              >
                <i className="fa fa-info-circle me-2"></i>
                Complete the current item details (Name, Quantity, Rate) to add
                more items
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemDetails;
